module.exports = __webpack_public_path__ + "static/media/info.6546c568.svg";